<script setup>
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useKanbanStore } from 'dashboard/stores/kanban';

import KanbanBoard from 'dashboard/components-next/Kanban/KanbanBoard.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const kanbanStore = useKanbanStore();

onMounted(() => {
  kanbanStore.fetchAll();
});
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-background">
    <div class="flex items-center justify-between px-6 py-4 border-b border-n-weak shrink-0">
      <h1 class="text-xl font-semibold text-n-slate-12">
        {{ t('KANBAN.TITLE') }}
      </h1>
      <Spinner v-if="kanbanStore.uiFlags.fetchingList" :size="16" />
    </div>
    <KanbanBoard />
  </div>
</template>
